import { render } from "./productBenefits.vue?vue&type=template&id=8ab45c1e&scoped=true"
import script from "./productBenefits.vue?vue&type=script&lang=js"
export * from "./productBenefits.vue?vue&type=script&lang=js"

import "./productBenefits.vue?vue&type=style&index=0&id=8ab45c1e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ab45c1e"]])

export default __exports__